import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initMfePrefetch } from './prefetch'
import * as analytics from '@innolab-trader/analytics'
import { ConfigManager } from '@innolab-trader/config'
import { initializeBootstrap, type BootstrapOptions, type PackageJson } from './bootstrap'
import packageJson from "../package.json";
import bootstrapDevelConfig from "../bootstrap.devel.json";

// Bootstrap initialization (required by MFEs)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const bootstrapOptions = bootstrapDevelConfig as any as BootstrapOptions;
initializeBootstrap(bootstrapOptions, packageJson as PackageJson);

// Kick off default MFE prefetch strategy
initMfePrefetch()

// Initialize analytics + Web Vitals (shell-level)
;(async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const opts: any = (bootstrapDevelConfig as any).analytics || {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wv: any = (bootstrapDevelConfig as any).webVitals || {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tracker: any | undefined
    if (opts.enabled) {
      const base = opts.useHeap && opts.heap
        ? analytics.heapTracker({ appId: opts.heap.appId, options: opts.heap.options })
        : analytics.consoleTracker()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const middlewares: any[] = [
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        analytics.contextEnricher({ app: 'shell', version: packageJson.version, env: (ConfigManager.get('stage') as any) || 'devel' })
      ]
      const rate = typeof opts.sampleRate === 'number' ? opts.sampleRate : 1
      if (rate >= 0 && rate < 1) middlewares.push(analytics.sampler(rate))
      tracker = analytics.createTracker(base, ...middlewares)
      analytics.setGlobalTracker(tracker)

      console.log('[Shell] Analytics tracker initialized')
    }

    if (wv.enabled) {
      analytics.initWebVitals({
        tracker,
        reportToConsole: wv.reportToConsole ?? true,
        reportToAnalytics: wv.reportToAnalytics ?? Boolean(tracker),
        debug: wv.debug ?? false,
      })

      console.log('[Shell] Web Vitals enabled')
    }
  } catch (e) {

    console.warn('[Shell] Analytics/Web Vitals init failed', e)
  }
})()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
